import { Link } from 'react-router-dom';
import { useSubmissions } from '@/hooks/useSubmissions';
import { PageSpinner } from '@/components/ui/Spinner';
import { ErrorState, EmptyState } from '@/components/ui/Alert';
import { getApiErrorMessage } from '@/api/client';
import { Badge } from '@/components/ui/Badge';
import { Card, CardBody } from '@/components/ui/Card';
import { submissionStatusLabel, submissionStatusTone } from '@/lib/submissions';
import { SubmissionThumbnail } from '@/components/submissions/SubmissionThumbnail';

export function UploadsPage() {
  // GET /submissions only accepts categoryId/competitionId/mine=true - there
  // is no competitorId filter, so "my uploads" means mine: true.
  const submissions = useSubmissions({ mine: true });

  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-xl font-semibold text-fg">Moji prispevki</h1>
      <p className="text-sm text-fg-muted">
        Za oddajo novega prispevka odprite tekmovanje, ki trenutno sprejema prispevke, na strani{' '}
        <Link to="/competitions" className="font-medium text-accent-text underline">
          Tekmovanja
        </Link>
        .
      </p>

      {submissions.isLoading && <PageSpinner />}
      {submissions.isError && (
        <ErrorState message={getApiErrorMessage(submissions.error)} onRetry={() => submissions.refetch()} />
      )}
      {submissions.isSuccess && submissions.data.items.length === 0 && (
        <EmptyState title="Ni še prispevkov" description="Tukaj bodo prikazani vaši oddani prispevki." />
      )}
      {submissions.isSuccess && submissions.data.items.length > 0 && (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {submissions.data.items.map((s) => (
            <Link key={s.id} to={`/submissions/${s.id}`}>
              <Card className="group h-full overflow-hidden">
                <div className="relative aspect-[4/3] w-full overflow-hidden bg-surface-3">
                  <SubmissionThumbnail submissionId={s.id} alt={s.title} />
                  <div className="pointer-events-none absolute inset-x-0 bottom-0 h-2/5 bg-scrim opacity-0 transition-opacity duration-fast group-hover:opacity-100" />
                </div>
                <CardBody>
                  <div className="flex items-center justify-between gap-2">
                    <h3 className="truncate text-sm font-medium text-fg">{s.title}</h3>
                    <Badge tone={submissionStatusTone(s.status)}>{submissionStatusLabel(s.status)}</Badge>
                  </div>
                </CardBody>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
